import * as types from './types';

const getters = {
  [types.GET_GLOBAL_MESSAGE]: (state) => state.globalMessage,
  [types.GET_CURRENCY_MAP]: (state) => state.currencyMap,
};

export default getters;
